

!(function (e) {
    var t = {};
    function i(n) {
        if (t[n]) return t[n].exports;
        var r = (t[n] = { i: n, l: !1, exports: {} });
        return e[n].call(r.exports, r, r.exports, i), (r.l = !0), r.exports;
    }
    (i.m = e),
        (i.c = t),
        (i.d = function (e, t, n) {
            i.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n });
        }),
        (i.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        (i.t = function (e, t) {
            if ((1 & t && (e = i(e)), 8 & t)) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if ((i.r(n), Object.defineProperty(n, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e))
                for (var r in e)
                    i.d(
                        n,
                        r,
                        function (t) {
                            return e[t];
                        }.bind(null, r)
                    );
            return n;
        }),
        (i.n = function (e) {
            var t =
                e && e.__esModule
                    ? function () {
                          return e.default;
                      }
                    : function () {
                          return e;
                      };
            return i.d(t, "a", t), t;
        }),
        (i.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (i.p = ""),
        i((i.s = 50));
})({
    12: function (e, t, i) {},
    16: function (e, t, i) {
        "undefined" != typeof self && self,
            (e.exports = (function (e) {
                function t(n) {
                    if (i[n]) return i[n].exports;
                    var r = (i[n] = { i: n, l: !1, exports: {} });
                    return e[n].call(r.exports, r, r.exports, t), (r.l = !0), r.exports;
                }
                var i = {};
                return (
                    (t.m = e),
                    (t.c = i),
                    (t.d = function (e, i, n) {
                        t.o(e, i) || Object.defineProperty(e, i, { configurable: !1, enumerable: !0, get: n });
                    }),
                    (t.n = function (e) {
                        var i =
                            e && e.__esModule
                                ? function () {
                                      return e.default;
                                  }
                                : function () {
                                      return e;
                                  };
                        return t.d(i, "a", i), i;
                    }),
                    (t.o = function (e, t) {
                        return Object.prototype.hasOwnProperty.call(e, t);
                    }),
                    (t.p = ""),
                    t((t.s = 0))
                );
            })([
                function (e, t, i) {
                    "use strict";
                    Object.defineProperty(t, "__esModule", { value: !0 });
                    var n =
                            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                                ? function (e) {
                                      return typeof e;
                                  }
                                : function (e) {
                                      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                                  },
                        r = (function () {
                            function e(e, t) {
                                for (var i = 0; i < t.length; i++) {
                                    var n = t[i];
                                    (n.enumerable = n.enumerable || !1), (n.configurable = !0), "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                                }
                            }
                            return function (t, i, n) {
                                return i && e(t.prototype, i), n && e(t, n), t;
                            };
                        })(),
                        s = (function () {
                            function e(t) {
                                var i = this;
                                if (
                                    ((function (e, t) {
                                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                                    })(this, e),
                                    (this.config = e.mergeSettings(t)),
                                    (this.selector = "string" == typeof this.config.selector ? document.querySelector(this.config.selector) : this.config.selector),
                                    null === this.selector)
                                )
                                    throw new Error("Something wrong with your selector 😭");
                                this.resolveSlidesNumber(),
                                    (this.selectorWidth = this.selector.offsetWidth),
                                    (this.innerElements = [].slice.call(this.selector.children)),
                                    (this.currentSlide = this.config.loop ? this.config.startIndex % this.innerElements.length : Math.max(0, Math.min(this.config.startIndex, this.innerElements.length - this.perPage))),
                                    (this.transformProperty = e.webkitOrNot()),
                                    ["resizeHandler", "touchstartHandler", "touchendHandler", "touchmoveHandler", "mousedownHandler", "mouseupHandler", "mouseleaveHandler", "mousemoveHandler", "clickHandler"].forEach(function (e) {
                                        i[e] = i[e].bind(i);
                                    }),
                                    this.init();
                            }
                            return (
                                r(
                                    e,
                                    [
                                        {
                                            key: "attachEvents",
                                            value: function () {
                                                window.addEventListener("resize", this.resizeHandler),
                                                    this.config.draggable &&
                                                        ((this.pointerDown = !1),
                                                        (this.drag = { startX: 0, endX: 0, startY: 0, letItGo: null, preventClick: !1 }),
                                                        this.selector.addEventListener("touchstart", this.touchstartHandler),
                                                        this.selector.addEventListener("touchend", this.touchendHandler),
                                                        this.selector.addEventListener("touchmove", this.touchmoveHandler),
                                                        this.selector.addEventListener("mousedown", this.mousedownHandler),
                                                        this.selector.addEventListener("mouseup", this.mouseupHandler),
                                                        this.selector.addEventListener("mouseleave", this.mouseleaveHandler),
                                                        this.selector.addEventListener("mousemove", this.mousemoveHandler),
                                                        this.selector.addEventListener("click", this.clickHandler));
                                            },
                                        },
                                        {
                                            key: "detachEvents",
                                            value: function () {
                                                window.removeEventListener("resize", this.resizeHandler),
                                                    this.selector.removeEventListener("touchstart", this.touchstartHandler),
                                                    this.selector.removeEventListener("touchend", this.touchendHandler),
                                                    this.selector.removeEventListener("touchmove", this.touchmoveHandler),
                                                    this.selector.removeEventListener("mousedown", this.mousedownHandler),
                                                    this.selector.removeEventListener("mouseup", this.mouseupHandler),
                                                    this.selector.removeEventListener("mouseleave", this.mouseleaveHandler),
                                                    this.selector.removeEventListener("mousemove", this.mousemoveHandler),
                                                    this.selector.removeEventListener("click", this.clickHandler);
                                            },
                                        },
                                        {
                                            key: "init",
                                            value: function () {
                                                this.attachEvents(), (this.selector.style.overflow = "hidden"), (this.selector.style.direction = this.config.rtl ? "rtl" : "ltr"), this.buildSliderFrame(), this.config.onInit.call(this);
                                            },
                                        },
                                        {
                                            key: "buildSliderFrame",
                                            value: function () {
                                                var e = this.selectorWidth / this.perPage,
                                                    t = this.config.loop ? this.innerElements.length + 2 * this.perPage : this.innerElements.length;
                                                (this.sliderFrame = document.createElement("div")),
                                                    (this.sliderFrame.style.width = e * t + "px"),
                                                    this.enableTransition(),
                                                    this.config.draggable && (this.selector.style.cursor = "-webkit-grab");
                                                var i = document.createDocumentFragment();
                                                if (this.config.loop)
                                                    for (var n = this.innerElements.length - this.perPage; n < this.innerElements.length; n++) {
                                                        var r = this.buildSliderFrameItem(this.innerElements[n].cloneNode(!0));
                                                        i.appendChild(r);
                                                    }
                                                for (var s = 0; s < this.innerElements.length; s++) {
                                                    var o = this.buildSliderFrameItem(this.innerElements[s]);
                                                    i.appendChild(o);
                                                }
                                                if (this.config.loop)
                                                    for (var a = 0; a < this.perPage; a++) {
                                                        var l = this.buildSliderFrameItem(this.innerElements[a].cloneNode(!0));
                                                        i.appendChild(l);
                                                    }
                                                this.sliderFrame.appendChild(i), (this.selector.innerHTML = ""), this.selector.appendChild(this.sliderFrame), this.slideToCurrent();
                                            },
                                        },
                                        {
                                            key: "buildSliderFrameItem",
                                            value: function (e) {
                                                var t = document.createElement("div");
                                                return (
                                                    (t.style.cssFloat = this.config.rtl ? "right" : "left"),
                                                    (t.style.float = this.config.rtl ? "right" : "left"),
                                                    (t.style.width = (this.config.loop ? 100 / (this.innerElements.length + 2 * this.perPage) : 100 / this.innerElements.length) + "%"),
                                                    t.appendChild(e),
                                                    t
                                                );
                                            },
                                        },
                                        {
                                            key: "resolveSlidesNumber",
                                            value: function () {
                                                if ("number" == typeof this.config.perPage) this.perPage = this.config.perPage;
                                                else if ("object" === n(this.config.perPage)) for (var e in ((this.perPage = 1), this.config.perPage)) window.innerWidth >= e && (this.perPage = this.config.perPage[e]);
                                            },
                                        },
                                        {
                                            key: "prev",
                                            value: function () {
                                                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                                                    t = arguments[1];
                                                if (!(this.innerElements.length <= this.perPage)) {
                                                    var i = this.currentSlide;
                                                    if (this.config.loop)
                                                        if (this.currentSlide - e < 0) {
                                                            this.disableTransition();
                                                            var n = this.currentSlide + this.innerElements.length,
                                                                r = this.perPage,
                                                                s = n + r,
                                                                o = (this.config.rtl ? 1 : -1) * s * (this.selectorWidth / this.perPage),
                                                                a = this.config.draggable ? this.drag.endX - this.drag.startX : 0;
                                                            (this.sliderFrame.style[this.transformProperty] = "translate3d(" + (o + a) + "px, 0, 0)"), (this.currentSlide = n - e);
                                                        } else this.currentSlide = this.currentSlide - e;
                                                    else this.currentSlide = Math.max(this.currentSlide - e, 0);
                                                    i !== this.currentSlide && (this.slideToCurrent(this.config.loop), this.config.onChange.call(this), t && t.call(this));
                                                }
                                            },
                                        },
                                        {
                                            key: "next",
                                            value: function () {
                                                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                                                    t = arguments[1];
                                                if (!(this.innerElements.length <= this.perPage)) {
                                                    var i = this.currentSlide;
                                                    if (this.config.loop)
                                                        if (this.currentSlide + e > this.innerElements.length - this.perPage) {
                                                            this.disableTransition();
                                                            var n = this.currentSlide - this.innerElements.length,
                                                                r = this.perPage,
                                                                s = n + r,
                                                                o = (this.config.rtl ? 1 : -1) * s * (this.selectorWidth / this.perPage),
                                                                a = this.config.draggable ? this.drag.endX - this.drag.startX : 0;
                                                            (this.sliderFrame.style[this.transformProperty] = "translate3d(" + (o + a) + "px, 0, 0)"), (this.currentSlide = n + e);
                                                        } else this.currentSlide = this.currentSlide + e;
                                                    else this.currentSlide = Math.min(this.currentSlide + e, this.innerElements.length - this.perPage);
                                                    i !== this.currentSlide && (this.slideToCurrent(this.config.loop), this.config.onChange.call(this), t && t.call(this));
                                                }
                                            },
                                        },
                                        {
                                            key: "disableTransition",
                                            value: function () {
                                                (this.sliderFrame.style.webkitTransition = "all 0ms " + this.config.easing), (this.sliderFrame.style.transition = "all 0ms " + this.config.easing);
                                            },
                                        },
                                        {
                                            key: "enableTransition",
                                            value: function () {
                                                (this.sliderFrame.style.webkitTransition = "all " + this.config.duration + "ms " + this.config.easing),
                                                    (this.sliderFrame.style.transition = "all " + this.config.duration + "ms " + this.config.easing);
                                            },
                                        },
                                        {
                                            key: "goTo",
                                            value: function (e, t) {
                                                if (!(this.innerElements.length <= this.perPage)) {
                                                    var i = this.currentSlide;
                                                    (this.currentSlide = this.config.loop ? e % this.innerElements.length : Math.min(Math.max(e, 0), this.innerElements.length - this.perPage)),
                                                        i !== this.currentSlide && (this.slideToCurrent(), this.config.onChange.call(this), t && t.call(this));
                                                }
                                            },
                                        },
                                        {
                                            key: "slideToCurrent",
                                            value: function (e) {
                                                var t = this,
                                                    i = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide,
                                                    n = (this.config.rtl ? 1 : -1) * i * (this.selectorWidth / this.perPage);
                                                e
                                                    ? requestAnimationFrame(function () {
                                                          requestAnimationFrame(function () {
                                                              t.enableTransition(), (t.sliderFrame.style[t.transformProperty] = "translate3d(" + n + "px, 0, 0)");
                                                          });
                                                      })
                                                    : (this.sliderFrame.style[this.transformProperty] = "translate3d(" + n + "px, 0, 0)");
                                            },
                                        },
                                        {
                                            key: "updateAfterDrag",
                                            value: function () {
                                                var e = (this.config.rtl ? -1 : 1) * (this.drag.endX - this.drag.startX),
                                                    t = Math.abs(e),
                                                    i = this.config.multipleDrag ? Math.ceil(t / (this.selectorWidth / this.perPage)) : 1,
                                                    n = e > 0 && this.currentSlide - i < 0,
                                                    r = e < 0 && this.currentSlide + i > this.innerElements.length - this.perPage;
                                                e > 0 && t > this.config.threshold && this.innerElements.length > this.perPage ? this.prev(i) : e < 0 && t > this.config.threshold && this.innerElements.length > this.perPage && this.next(i),
                                                    this.slideToCurrent(n || r);
                                            },
                                        },
                                        {
                                            key: "resizeHandler",
                                            value: function () {
                                                this.resolveSlidesNumber(),
                                                    this.currentSlide + this.perPage > this.innerElements.length && (this.currentSlide = this.innerElements.length <= this.perPage ? 0 : this.innerElements.length - this.perPage),
                                                    (this.selectorWidth = this.selector.offsetWidth),
                                                    this.buildSliderFrame();
                                            },
                                        },
                                        {
                                            key: "clearDrag",
                                            value: function () {
                                                this.drag = { startX: 0, endX: 0, startY: 0, letItGo: null, preventClick: this.drag.preventClick };
                                            },
                                        },
                                        {
                                            key: "touchstartHandler",
                                            value: function (e) {
                                                -1 !== ["TEXTAREA", "OPTION", "INPUT", "SELECT"].indexOf(e.target.nodeName) ||
                                                    (e.stopPropagation(), (this.pointerDown = !0), (this.drag.startX = e.touches[0].pageX), (this.drag.startY = e.touches[0].pageY));
                                            },
                                        },
                                        {
                                            key: "touchendHandler",
                                            value: function (e) {
                                                e.stopPropagation(), (this.pointerDown = !1), this.enableTransition(), this.drag.endX && this.updateAfterDrag(), this.clearDrag();
                                            },
                                        },
                                        {
                                            key: "touchmoveHandler",
                                            value: function (e) {
                                                if (
                                                    (e.stopPropagation(),
                                                    null === this.drag.letItGo && (this.drag.letItGo = Math.abs(this.drag.startY - e.touches[0].pageY) < Math.abs(this.drag.startX - e.touches[0].pageX)),
                                                    this.pointerDown && this.drag.letItGo)
                                                ) {
                                                    e.preventDefault(),
                                                        (this.drag.endX = e.touches[0].pageX),
                                                        (this.sliderFrame.style.webkitTransition = "all 0ms " + this.config.easing),
                                                        (this.sliderFrame.style.transition = "all 0ms " + this.config.easing);
                                                    var t = (this.config.loop ? this.currentSlide + this.perPage : this.currentSlide) * (this.selectorWidth / this.perPage),
                                                        i = this.drag.endX - this.drag.startX,
                                                        n = this.config.rtl ? t + i : t - i;
                                                    this.sliderFrame.style[this.transformProperty] = "translate3d(" + (this.config.rtl ? 1 : -1) * n + "px, 0, 0)";
                                                }
                                            },
                                        },
                                        {
                                            key: "mousedownHandler",
                                            value: function (e) {
                                                -1 !== ["TEXTAREA", "OPTION", "INPUT", "SELECT"].indexOf(e.target.nodeName) || (e.preventDefault(), e.stopPropagation(), (this.pointerDown = !0), (this.drag.startX = e.pageX));
                                            },
                                        },
                                        {
                                            key: "mouseupHandler",
                                            value: function (e) {
                                                e.stopPropagation(), (this.pointerDown = !1), (this.selector.style.cursor = "-webkit-grab"), this.enableTransition(), this.drag.endX && this.updateAfterDrag(), this.clearDrag();
                                            },
                                        },
                                        {
                                            key: "mousemoveHandler",
                                            value: function (e) {
                                                if ((e.preventDefault(), this.pointerDown)) {
                                                    "A" === e.target.nodeName && (this.drag.preventClick = !0),
                                                        (this.drag.endX = e.pageX),
                                                        (this.selector.style.cursor = "-webkit-grabbing"),
                                                        (this.sliderFrame.style.webkitTransition = "all 0ms " + this.config.easing),
                                                        (this.sliderFrame.style.transition = "all 0ms " + this.config.easing);
                                                    var t = (this.config.loop ? this.currentSlide + this.perPage : this.currentSlide) * (this.selectorWidth / this.perPage),
                                                        i = this.drag.endX - this.drag.startX,
                                                        n = this.config.rtl ? t + i : t - i;
                                                    this.sliderFrame.style[this.transformProperty] = "translate3d(" + (this.config.rtl ? 1 : -1) * n + "px, 0, 0)";
                                                }
                                            },
                                        },
                                        {
                                            key: "mouseleaveHandler",
                                            value: function (e) {
                                                this.pointerDown &&
                                                    ((this.pointerDown = !1),
                                                    (this.selector.style.cursor = "-webkit-grab"),
                                                    (this.drag.endX = e.pageX),
                                                    (this.drag.preventClick = !1),
                                                    this.enableTransition(),
                                                    this.updateAfterDrag(),
                                                    this.clearDrag());
                                            },
                                        },
                                        {
                                            key: "clickHandler",
                                            value: function (e) {
                                                this.drag.preventClick && e.preventDefault(), (this.drag.preventClick = !1);
                                            },
                                        },
                                        {
                                            key: "remove",
                                            value: function (e, t) {
                                                if (e < 0 || e >= this.innerElements.length) throw new Error("Item to remove doesn't exist 😭");
                                                var i = e < this.currentSlide,
                                                    n = this.currentSlide + this.perPage - 1 === e;
                                                (i || n) && this.currentSlide--, this.innerElements.splice(e, 1), this.buildSliderFrame(), t && t.call(this);
                                            },
                                        },
                                        {
                                            key: "insert",
                                            value: function (e, t, i) {
                                                if (t < 0 || t > this.innerElements.length + 1) throw new Error("Unable to inset it at this index 😭");
                                                if (-1 !== this.innerElements.indexOf(e)) throw new Error("The same item in a carousel? Really? Nope 😭");
                                                var n = t <= this.currentSlide > 0 && this.innerElements.length;
                                                (this.currentSlide = n ? this.currentSlide + 1 : this.currentSlide), this.innerElements.splice(t, 0, e), this.buildSliderFrame(), i && i.call(this);
                                            },
                                        },
                                        {
                                            key: "prepend",
                                            value: function (e, t) {
                                                this.insert(e, 0), t && t.call(this);
                                            },
                                        },
                                        {
                                            key: "append",
                                            value: function (e, t) {
                                                this.insert(e, this.innerElements.length + 1), t && t.call(this);
                                            },
                                        },
                                        {
                                            key: "destroy",
                                            value: function () {
                                                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                                                    t = arguments[1];
                                                if ((this.detachEvents(), (this.selector.style.cursor = "auto"), e)) {
                                                    for (var i = document.createDocumentFragment(), n = 0; n < this.innerElements.length; n++) i.appendChild(this.innerElements[n]);
                                                    (this.selector.innerHTML = ""), this.selector.appendChild(i), this.selector.removeAttribute("style");
                                                }
                                                t && t.call(this);
                                            },
                                        },
                                    ],
                                    [
                                        {
                                            key: "mergeSettings",
                                            value: function (e) {
                                                var t = {
                                                        selector: ".siema",
                                                        duration: 200,
                                                        easing: "ease-out",
                                                        perPage: 1,
                                                        startIndex: 0,
                                                        draggable: !0,
                                                        multipleDrag: !0,
                                                        threshold: 20,
                                                        loop: !1,
                                                        rtl: !1,
                                                        onInit: function () {},
                                                        onChange: function () {},
                                                    },
                                                    i = e;
                                                for (var n in i) t[n] = i[n];
                                                return t;
                                            },
                                        },
                                        {
                                            key: "webkitOrNot",
                                            value: function () {
                                                return "string" == typeof document.documentElement.style.transform ? "transform" : "WebkitTransform";
                                            },
                                        },
                                    ]
                                ),
                                e
                            );
                        })();
                    (t.default = s), (e.exports = t.default);
                },
            ]));
    },
    4: function (e, t, i) {},
    5: function (e, t, i) {
        "use strict";
        i.d(t, "a", function () {
            return n;
        }),
            i.d(t, "c", function () {
                return s;
            }),
            i.d(t, "d", function () {
                return o;
            }),
            i.d(t, "b", function () {
                return a;
            }),
            i(12);
            const n = ({ responseData: e }) => {
                let freeReturn = `<div class="sidecart-message ty"> <div class="media"> <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M26.9715 17.724C30.1685 11.709 30.16 6.5605 28.6995 4.092C28.092 3.0655 27.2305 2.5 26.274 2.5C26.18 2.5 26.0845 2.5055 25.9905 2.517C24.422 2.705 23.813 4.486 22.969 6.9505C22.3715 8.696 21.6295 10.842 20.407 12.951C19.7285 12.0635 18.873 11.32 17.9515 10.882L17.9605 10.877C17.9315 10.8655 17.905 10.8575 17.876 10.8455C17.6286 10.7292 17.3714 10.6348 17.1075 10.5635C17.0185 10.541 16.9315 10.5235 16.8445 10.505C10.293 8.777 8.2155 17.138 11.7305 16.085C12.7545 15.778 13.446 14.1035 15.5345 12.4205C17.106 13.3745 18.14 15.073 17.781 16.314C16.5875 20.441 12.983 22.3175 8.857 22.3175C7.9275 22.3175 6.9715 22.2225 6.011 22.036C5.63593 21.9612 5.26495 21.8673 4.8995 21.7545C4.14828 21.5296 3.42069 21.2322 2.727 20.8665L1 22.342C1.42683 23.0138 1.90811 23.6495 2.439 24.2425C4.3595 26.395 6.9095 27.9455 9.8615 28.518C14.492 29.4155 19.0005 27.7075 22.0615 24.3725C23.7555 22.237 25.3855 21.347 26.7805 21.0785C26.5105 24.709 23.719 29.5 25.5965 29.5C25.668 29.5 25.747 29.4925 25.8325 29.4785C29.1585 28.923 31.1065 24.744 30.9955 22.096C30.877 19.2575 28.668 18.154 26.9715 17.724ZM20.587 18.1575C19.042 22.64 14.273 24.9165 9.413 24.9165C8.0515 24.9165 6.6735 24.708 5.335 24.311C5.013 24.1672 4.69707 24.0103 4.388 23.8405C4.6978 23.5397 4.99329 23.2245 5.2735 22.896C5.4635 22.944 5.644 22.984 5.821 23.018C6.847 23.2165 7.869 23.3175 8.8575 23.3175C11.294 23.3175 13.421 22.7105 15.103 21.5985C15.7135 21.814 16.575 21.682 17.3845 21.1735C18.5725 20.4275 19.1775 19.1765 18.7365 18.3785C18.6245 18.1765 18.45 18.032 18.2405 17.9295C18.436 17.504 18.6065 17.0605 18.7425 16.5915C19.0395 15.564 18.727 14.332 17.884 13.212C17.4652 12.6625 16.9631 12.1817 16.396 11.787C16.528 11.698 16.6665 11.61 16.8085 11.522C16.8254 11.5268 16.8426 11.5303 16.86 11.5325C18.271 11.6945 21.7085 14.903 20.587 18.1575ZM25.948 17.5255C23.2105 17.142 21.479 18.6085 21.479 18.6085C22.1355 16.8195 21.812 15.0905 21.024 13.879C24.0635 8.9145 24.328 3.7235 26.11 3.51C26.165 3.503 26.2195 3.5 26.274 3.5C28.6105 3.5 30.298 9.5555 25.948 17.5255ZM25.9695 28.4275C26.057 27.831 26.3875 26.7855 26.6435 25.9755C27.306 23.8785 28.195 21.066 27.6025 18.9625C28.7765 19.4395 29.922 20.3605 29.9965 22.1385C30.086 24.2815 28.533 27.7625 25.9695 28.4275Z" fill="#FF3D00"/> </svg> <div class="media-body"> <h5>Shop with confidence, returns are free</h5></div></div></div><div class="ymal-carousel-wrapper"></div>`;
                    const { items: t, item_count: i, total_price: n } = e;
                    if(t.length == 0) {
                        freeReturn = '';
                    }
                    else {
                        var carousel = document.createElement("div");
                        fetch('/collections/best-sellers-1?view=ymal').then(function (response) {
                            // The API call was successful!
                            return response.text();
                        }).then(function (html) {
                            var parser = new DOMParser();
                            var doc = parser.parseFromString(html, 'text/html');
                            carousel.appendChild(doc.querySelector('.side-ymal'));
                            appendDiv(carousel);
                        }).catch(function (err) {
                            // There was an error
                            console.warn('Something went wrong.', err);
                        });
                    }
                                      
                     window.checkcart = e;
                  
                  let current_value = e.total_price / 100,
                  progress_limit = window.gift_goals.limit,
                  current_progress = current_value / progress_limit * 100;
                  
                  var goal_template = ``;

                  var totalPrice_ = 0 ; 
                  let cont = 0;

                  for( let goal in gift_goals.goals){
                      
                      totalPrice_ = window.gift_goals.limit ;
                      let offset = window.gift_goals.goals[goal].value / window.gift_goals.limit * 100,
                      goal_classes;
                      if(current_value >= window.gift_goals.goals[goal].value){
                          goal_classes = 'goal-marker goal-reached';
          
                          if(window.gift_goals.goals[goal].variant != ''){
                  
                              let current_variants_in_cart = []; 
                              for(x in e.items){
                                  current_variants_in_cart.push(e.items[x].variant_id);
                              }
                  
                              if(!current_variants_in_cart.includes(parseFloat(window.gift_goals.goals[goal].variant))){
                                  ajaxAddToCart(window.gift_goals.goals[goal].variant);
                              }
                  
                          }
          
                      } else{
                          goal_classes = 'goal-marker';
                      }
                      
                      goal_template += `
                      <div class="${goal_classes}" style="left: calc(${offset}% - 16px);">
                          <span>${parseFloat(window.gift_goals.goals[goal].value) == 0 ? `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.88667 21.3335C9.71509 21.3335 10.3867 20.6619 10.3867 19.8335C10.3867 19.0051 9.71509 18.3335 8.88667 18.3335C8.05824 18.3335 7.38667 19.0051 7.38667 19.8335C7.38667 20.6619 8.05824 21.3335 8.88667 21.3335Z" fill="black"/>
                          <path d="M18 21.3335C18.8284 21.3335 19.5 20.6619 19.5 19.8335C19.5 19.0051 18.8284 18.3335 18 18.3335C17.1716 18.3335 16.5 19.0051 16.5 19.8335C16.5 20.6619 17.1716 21.3335 18 21.3335Z" fill="black"/>
                          <path d="M22.0533 3.57991C21.9913 3.50343 21.9131 3.44165 21.8243 3.399C21.7356 3.35635 21.6385 3.33389 21.54 3.33324H7.66L8.09333 4.66658H20.6667L18.8867 12.6666H8.88666L5.84 3.01991C5.80704 2.91755 5.74982 2.82468 5.6732 2.74922C5.59658 2.67377 5.50285 2.61796 5.4 2.58658L2.66666 1.74658C2.58262 1.72075 2.49431 1.71173 2.40678 1.72003C2.31924 1.72833 2.23421 1.7538 2.15651 1.79496C1.99961 1.8781 1.88216 2.02017 1.83 2.18991C1.77784 2.35965 1.79524 2.54316 1.87838 2.70006C1.96153 2.85697 2.10359 2.97442 2.27333 3.02658L4.66666 3.75991L7.72667 13.4266L6.63333 14.3199L6.54666 14.4066C6.27622 14.7182 6.12293 15.1145 6.1132 15.527C6.10346 15.9395 6.23789 16.3425 6.49333 16.6666C6.67504 16.8875 6.90594 17.0629 7.16756 17.1787C7.42918 17.2945 7.71426 17.3474 8 17.3332H19.1267C19.3035 17.3332 19.473 17.263 19.5981 17.138C19.7231 17.013 19.7933 16.8434 19.7933 16.6666C19.7933 16.4898 19.7231 16.3202 19.5981 16.1952C19.473 16.0701 19.3035 15.9999 19.1267 15.9999H7.89333C7.81656 15.9973 7.74177 15.9749 7.67617 15.9349C7.61057 15.895 7.55639 15.8388 7.51886 15.7717C7.48133 15.7047 7.46172 15.6292 7.46192 15.5523C7.46211 15.4755 7.48212 15.4001 7.52 15.3332L9.12666 13.9999H19.42C19.5741 14.0037 19.7248 13.9539 19.8463 13.8591C19.9679 13.7643 20.0528 13.6303 20.0867 13.4799L22.2 4.14658C22.2203 4.04719 22.2176 3.94448 22.1922 3.84629C22.1668 3.74809 22.1193 3.65698 22.0533 3.57991Z" fill="black"/>
                          </svg>
                          `: `$`+window.gift_goals.goals[goal].value }</span>
                          <span>${goal}</span>
                      </div>
                      `;

                      
                  }

                    var missingValue = totalPrice_ - current_value ;
                    var renderMissingValue = current_progress < 100 ? 
                    (   'You are' + " " + "$" +  " " + missingValue + " " + 'away from getting free 2-day shipping' ) : 
                    (   'Made It! Enjoy Your Free 2-Day Shipping');       

                    let sideCartGoals = `<div class="container-goals"><div class="sidecart__goals-header"><div class="container-goals-missingValue">${renderMissingValue} </div></div> <div class="sidecart__goals"><div class="sidecart__goals--progress" style="width:${current_progress}%;"></div>${goal_template}</div></div>`


                     return `\n    <div class="test mini-cart-inner">\n      <div class="cart-header">\n        <span class="desktop caps">Shopping Cart: ${n}\n        </span>\n        <button class="close">×</button>\n      </div>\n ${ window.gift_goals ? sideCartGoals : '' }\n     <div class="mini-cart-items caps">\n ${t
                        .map((e, t) => r({ ...e, i: t }))
                        .join("")}\n ${freeReturn}</div>\n \n<div class="mini-cart-bottom">\n        <div class=" ty mini-cart-total">Subtotal: $${
                        o / 100
                    }</div>\n        <div class="mini-cart-message">Free Domestic Shipping & Returns</div>\n      </div>\n      <a class="checkout  yu" href="/checkout" onClick=()>\n        Checkout\n      </a>\n    </div>\n`;
                },
                r = ({ product_title: e, variant_title: t, quantity: i, price: n, image: r, discounts: d, i: s, url:a }) =>
                {
	               var sourceURL=a;
	               var rtn = sourceURL.split("?")[0],
	                param,
	                params_arr = [],
	                queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
	                if (queryString !== "") {
	                params_arr = queryString.split("&");
	                for (var i = params_arr.length - 1; i >= 0; i -= 1) {
	                    param = params_arr[i].split("=")[0];
	                    if (param === 'variant') {
	                        params_arr.splice(i, 1);
	                    }
	                }
	                if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
	                }
	               	var mytag=false;
	                $.ajax({
	                    url: rtn+'.js',
	                    async: false,
	                    dataType: 'json',
	                      success: function(product){
                            document.querySelector(".mini-cart-link").click()
	                     if (product.tags.indexOf("final-sale") > -1) {
	                        mytag= true;
	                    }
	                  }});
                  return  `\n    <div class="cart-item">\n      <div class="cart-item-info">\n        <div class="cart-item-properties ty">\n          <h3 class="title">${e}</h3>\n          <p class="variant-title tyyy">${t}</p>\n  `+(mytag?'<p class="final-sale-cart">Final-sale</p>':'')+`        <p class="ty price">$${
                        n / 100
                    } \n ${ d.length > 0 ? `<span class="cart-item-discounts">${d[0].title} (-$${ (d[0].amount / 100).toFixed(2) })</span>`: '' }</p>\n          ${i > 1 ? `<p class='cart-quantity'>Qty: ${i}</p>` : ""}\n        </div>\n        <button class="remove ty" data-line-item="${
                        +s + 1
                    }">Remove</button>\n      </div>\n      <div class="cart-item-image">\n        ${r ? `<img src="${r}"/>` : ""}\n      </div>\n    </div>\n  `;
                }
            function s() {
            return window
                .fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json", "Content-Type": "application/json" } })
                .then((e) => e.json())
                .catch((e) => {
                    throw new Error(e);
                });
        }

        function o({ id: e, quantity: t, properties: i }) {
            const n = JSON.stringify({ id: e, quantity: t, properties: i });
          console.log(n);
            return window
                .fetch("/cart/add.js", { headers: { "Content-Type": "application/json" }, credentials: "same-origin", method: "POST", body: n })
                .then((e) => e.json())
                .catch((e) => {
                    throw new Error(e);
                });
        }

      
        function a({ line: e }) {
            return (function ({ line: e, quantity: t }) {
                const i = JSON.stringify({ line: e, quantity: t });
                return window
                    .fetch("/cart/change.js", { headers: { "Content-Type": "application/json" }, credentials: "same-origin", method: "POST", body: i })
                    .then((e) => e.json())
                    .catch((e) => {
                        throw new Error(e);
                    });
            })({ line: e, quantity: 0 });
        }
        function appendDiv (div){
            document.querySelector('.ymal-carousel-wrapper').appendChild(div);
            var elem = document.querySelector('.ymal-carousel');
            var flkty = new Flickity( elem, {
            // options
            cellAlign: 'center',
            freeScroll: true,
            wrapAround: true,
            groupCells: 2,
            pageDots: false,
            setGallerySize: false
            });
        }        
    },
    50: function (e, t, i) {
        "use strict";
        i.r(t), i(51), i(6), i(4), i(8);
        var n = i(16),
            r = i.n(n),
            s = i(5);
        const o = (e) => e.available;
        document.addEventListener("DOMContentLoaded", (e) => {
            var t = document.querySelectorAll(".extras .block");
            t.forEach((e) => {
                e.addEventListener("click", (i) => {
                    e.classList.contains("expanded") ? t.forEach((e) => e.classList.remove("expanded")) : (t.forEach((e) => e.classList.remove("expanded")), e.classList.add("expanded"));
                });
            });
            const i = document.querySelector(".add-to-cart"),
                n = document.querySelector(".add-to-cart-form");
            var a = Array.from(document.querySelectorAll("input[checked]")).map((e) => e.value);
            const l = Array.from(document.querySelectorAll(".variants option")).map((e) => e.dataset);
            var c;
            let filter_drop_obj = '';
            l.forEach((e) => {
                if (!e.available) {
                    var t = e.title.split(" / ")[0];
                    document.querySelector(`.value[data-value='${t}']`).classList.add("disabled");
                }
            }),
                n.addEventListener("change", ({ target: e }) => {
                    const { index: t } = e.dataset;
                    a[t] = e.value;
                    const i = l.filter(o);
                    console.log({ filteredVariants: i });
                    filter_drop_obj = { filteredVariants: i };
                    const n = l.filter(o).find((e) => e.title === a.join(" / ")),
                        r = document.getElementsByTagName("klarna-placement");
                    n
                        ? (document.querySelector("button.add-to-cart").removeAttribute("disabled"),
                          (document.querySelector("button.add-to-cart span").innerHTML = "Add To Cart"),
                          history.replaceState("", "", n.url),
                          document.querySelector("#BIS_trigger").classList.add("hidden"),
                          r.forEach((e) => {
                              e.setAttribute("data-purchase-amount", n.price), e.classList.remove("hidden");
                          }),
                          (window.KlarnaOnsiteService = window.KlarnaOnsiteService || []),
                          window.KlarnaOnsiteService.push({ eventName: "refresh-placements" }))
                        : (document.querySelector("#BIS_trigger").classList.remove("hidden"),
                          r.forEach((e) => {
                              e.classList.add("hidden");
                          })),
                        n && (document.querySelector('select[name="id"]').value = n.id);
                }),
                i.addEventListener("click", async (e) => {
                    e.preventDefault();
                    if (window.waiting_atc == true) {
                        return;
                      }
                    window.waiting_atc = true;
                    var windowSize = $(window).width();
                    let select_value = '';
                    let t = '';
                    // if (windowSize < 768) {
                    //     select_value = $('.frm-sticky').find('.selected-value').attr("data-productid");

                    //   console.log(select_value);
                    //     if($('.frm-sticky').find('select').length){
                    //         t = select_value;
                      
                    //     }else{
                    //         t = n.id.value;
                    //     }
                    // }else{
                     
                    //     select_value = e.target.closest('form').querySelector('[name="id"]').value;
                    //     //t = select_value;
                    //    alert(select_value);
                    // }
               
                    if (windowSize < 768) {
                      select_value = $('.frm-sticky').find('.selected-value').attr("data-productid");
                    }else{
                         select_value = e.target.closest('form').querySelector('[name="id"]').value;
                    }
                    if(select_value !== 'placeholder' && t != null){
                      
                        const t = select_value;
                      console.log('t: '+t);
                        await Object(s.d)({ id: t, quantity: 1 }),
                            Object(s.c)().then((e) => {
                                document.querySelector("#shopify-section-mini-cart").classList.add("open"),
                                    (document.querySelector("#mini-cart-container").innerHTML = Object(s.a)({ responseData: e })),
                                    (document.querySelector(".mini-cart-link .count").innerHTML = e.item_count);
                            });
                    }else{
                     console.log('else work');
                        const newDiv = document.createElement("div");
                        const newContent = document.createTextNode("⚠️ \u00A0 SELECT A SIZE");
                        newDiv.appendChild(newContent);
                        newDiv.classList.add('disclaimer-select-a-size');
                        document.querySelector('body').after(newDiv, document.querySelector('body'));
                        setTimeout(() => {document.querySelector('.disclaimer-select-a-size').remove();}, 5000); 


                      
                    }
                    window.waiting_atc = false;
                });
            const h = {
                    selector: ".product-images",
                    duration: 200,
                    easing: "ease-out",
                    perPage: 1,
                    startIndex: 0,
                    draggable: !0,
                    multipleDrag: !0,
                    threshold: 20,
                    loop: !1,
                    rtl: !1,
                    onInit: function () {
                        this.addDots(), this.updateDots();
                    },
                    onChange: function () {
                        this.updateDots();
                    },
                },
                d = (e) => {
                    e.matches
                        ? c && (c.destroy(!0), (c = !1))
                        : (c = new (class extends r.a {
                              addDots() {
                                  (this.dots = document.createElement("div")), this.dots.classList.add("dots");
                                  for (let e = 0; e < this.innerElements.length; e++) {
                                      const t = document.createElement("button");
                                      t.classList.add("dots__item"),
                                        t.setAttribute("aria-label", `Change slide ${e + 1}`);
                                          t.addEventListener("click", () => {
                                              this.goTo(e);
                                          }),
                                          this.dots.appendChild(t);
                                  }
                                  this.selector.parentNode.insertBefore(this.dots, this.selector.nextSibling);
                              }
                              updateDots() {
                                  for (let e = 0; e < this.dots.querySelectorAll("button").length; e++) {
                                      const t = this.currentSlide === e ? "add" : "remove";
                                      this.dots.querySelectorAll("button")[e].classList[t]("dots__item--active");
                                  }
                              }
                          })(h));
                };
            d(matchMedia("(min-width: 1024px)")), matchMedia("(min-width: 1024px)").addListener(d);
        });
    },
    51: function (e, t, i) {},
    6: function (e, t, i) {},
    8: function (e, t, i) {},
});
